import * as actions from "../actions";
import * as api from "../../api";

export const fetchOrganizationConfiguration = (organizationId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.fetchOrganizationConfiguration(api.fetchOrganizationConfiguration(token,organizationId)));
  };
};

export const saveIbanAndBic = (id, iban, bic, payConiqAccessTockenOnLine, payConiqMerchandIdOnLine, payConiqPaymentProfileIdInvoice, payConiqAccessTockenInvoice, payConiqMerchandIdInvoice,contact,imapMailBox,  imapUserName, imapPassWord,imapFromEmail, imapPort, ftpHost, ftpUserName, ftpPassword, ftpPort, ftpProtocol, dropboxFolder, isDropboxImportActive, currentClient) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.saveIbanAndBic(api.saveIbanAndBic(token,id, iban, bic, payConiqAccessTockenOnLine, payConiqMerchandIdOnLine, payConiqPaymentProfileIdInvoice, payConiqAccessTockenInvoice, payConiqMerchandIdInvoice, contact,imapMailBox,  imapUserName, imapPassWord,imapFromEmail, imapPort, ftpHost, ftpUserName, ftpPassword, ftpPort, ftpProtocol, dropboxFolder, isDropboxImportActive, currentClient)));
  };
};

export const displayCodaFileTestfFile = ( appRef) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.displayCodaFileTestfFile(token, appRef);
  };
};

export const searchUsers = (email = '') => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;

    return dispatch(actions.searchUsers(api.searchOrganizationUsersByEmail(token, email, currentClient.id)));
  };
};

export const fetchActions = () => {
  return (dispatch, getState) => {
    const {token} = getState().auth;

    return dispatch(actions.fetchActions(api.fetchActions(token)));
  };
};

export const fetchEmailTypes = () => {
  return (dispatch, getState) => {
    const {token} = getState().auth;

    return dispatch(actions.fetchEmailTypes(api.fetchEmailTypes(token)));
  };
};

export const saveActionsConfiguration = (id, actionName, emailType, nbrHours) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return dispatch(actions.saveActionsConfiguration(api.saveActionsConfiguration(token, id, currentClient.id, actionName, emailType, nbrHours)));
  };
};

export const fetchAction = (actionName) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return api.fetchAction(token, actionName, currentClient.id);
  };
};

export const saveOrganizationRelanceConfiguration = ({id, isRelanceActive, isImportImapActive}) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.saveOrganizationRelanceConfiguration({token, id, isRelanceActive, isImportImapActive});
  };
};

export const getRemindersToSend = (issuer) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.getRemindersToSend(token, issuer);
  };
};

export const cancelReminders = (issuer) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.cancelReminders(token, issuer);
  };
};

export const testImapConnection = (mailbox,userName, password, fromEmail, imapPort) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.testImapConnection(token, mailbox,userName, password, fromEmail, imapPort);
  };
};

export const testFtpConnection = (ftpHost,ftpUserName, ftpPassWord, ftpPort, ftpProtocol) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.testFtpConnection(token, ftpHost,ftpUserName, ftpPassWord, ftpPort, ftpProtocol);
  };
};

export const uploadModels = (models) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return api.uploadModels(token, currentClient.id, models);
  };
};

export const getUploadedModels = () => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return api.getUploadedModels(token, currentClient.id);
  };
};

export const dropboxFolderExists = (path) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return api.dropboxFolderExists(token, currentClient.id, path);
  };
};

export const forceCodaImport = () => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return api.forceCodaImport(token, currentClient.id);
  };
};

export const createSepaFile = (issuerId, amount, iban, bic, companyName, wireReference) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return api.createSepaFile(token, issuerId, amount, iban, bic, companyName, wireReference);
  };
};

export const saveBankTransferConfig = (id, iban, bic) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return api.saveBankTransferConfig(token,id, iban, bic, currentClient.id);
  };
};

export const savePayconiqConfig = (id, payConiqAccessTockenOnLine, payConiqMerchandIdOnLine, payConiqPaymentProfileIdInvoice, payConiqAccessTockenInvoice, payConiqMerchandIdInvoice) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return api.savePayconiqConfig(token,id, payConiqAccessTockenOnLine, payConiqMerchandIdOnLine, payConiqPaymentProfileIdInvoice, payConiqAccessTockenInvoice, payConiqMerchandIdInvoice, currentClient.id);
  };
};

export const saveOrganizationContact = (id, contact) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.saveOrganizationContact(token, id, contact);
  };
};






// WEBPACK FOOTER //
// ./app/actions/thunks/organizationConfiguration.js